import { Menu as MenuIcon } from "@mui/icons-material";
import {
  AppBar,
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isExistsCookies } from "utils/cookies";

export function HomeHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const isAuthenticated = isExistsCookies();
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const homeMenu = [
    {
      name: "Beranda",
      link: "/",
    },
    {
      name: "Profil",
      link: "/profile",
    },
    {
      name: "Edukasi",
      link: "/education",
    },
    {
      name: "Bantuan",
      link: "/help",
    },
  ];
  if (isAuthenticated) {
    homeMenu.push({
      name: "Pemesanan",
      link: "/dashboard",
    });
  }

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        MENU
      </Typography>
      <Divider />
      <List>
        {homeMenu.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton
              sx={{ textAlign: "center" }}
              onClick={() => navigate(item.link)}
            >
              <ListItemText primary={item.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      const isTop = window.scrollY > 100;
      if (isTop !== isScrolled) {
        setIsScrolled(isTop);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolled]);

  return (
    <AppBar
      position="fixed"
      component="nav"
      className={
        !isHomePage || isScrolled
          ? "header-app-bar"
          : "header-home-page-app-bar"
      }
    >
      <Toolbar disableGutters className="header-toolbar">
        <div className="header-logo">
          <img
            className="header-logo-image"
            src="/assets/images/logo-ngawi.webp"
            alt="Logo"
          />
          <div
            className={
              !isHomePage || isScrolled
                ? "header-logo-text"
                : "header-home-page-logo-text"
            }
          >
            <span>Instalasi Pengolahan Lumpur Tinja</span>
            <span>Dinas Perumahan Rakyat dan</span>
            <span>Kawasan Permukiman Kab. Ngawi</span>
          </div>
        </div>
        <div className="header-menu">
          {!isHomePage || isScrolled
            ? homeMenu.map((item, index) => (
                <Button
                  key={index} // Use index as the key
                  className={
                    item.link === location.pathname
                      ? "header-menu-button-active"
                      : "header-menu-button"
                  }
                  variant="outlined"
                  size="small"
                  onClick={() => navigate(item.link)}
                >
                  {item.name}
                </Button>
              ))
            : homeMenu.map((item, index) => (
                <Button
                  key={index} // Use index as the key
                  className={
                    item.link === location.pathname
                      ? "header-home-page-menu-button-active"
                      : "header-home-page-menu-button"
                  }
                  variant="outlined"
                  size="small"
                  onClick={() => navigate(item.link)}
                >
                  {item.name}
                </Button>
              ))}
        </div>
        <div className="header-menu-mobile">
          <IconButton
            className={
              !isHomePage || isScrolled
                ? "header-menu-icon-mobile"
                : "header-home-page-menu-icon-mobile"
            }
            aria-label="open drawer"
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
        </div>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { md: "block", lg: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: 240,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Toolbar>
    </AppBar>
  );
}
